<template>
  <config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </config-provider>
</template>
<script>
import ConfigProvider from 'ant-design-vue/lib/config-provider'
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enquireScreen from '@/utils/device'

export default {
  components: { ConfigProvider },
  data () {
    return {
      locale: zhCN,
    }
  },
  created () {
    let that = this
    enquireScreen(deviceType => {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      }
      // mobile
      else if (deviceType === 1) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      }
      else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        that.$store.dispatch('setSidebar', true)
      }

    })
  }
}
</script>
<style>
#app {
  height: 100%;
}

/* 大屏数据设置表单下拉框全局样式 */
.ant-select-dropdown {
  background: rgba(20, 30, 40, 0.98) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 221, 255, 0.3) !important;
}

.ant-select-dropdown .ant-select-dropdown-menu-item {
  color: rgba(255, 255, 255, 0.9) !important;
}

.ant-select-dropdown .ant-select-dropdown-menu-item:hover {
  background: rgba(108, 221, 255, 0.15) !important;
}

.ant-select-dropdown .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected {
  background: rgba(108, 221, 255, 0.25) !important;
  color: #6cddff !important;
}

.ant-select-dropdown .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {
  background: rgba(108, 221, 255, 0.2) !important;
}

/* 树形下拉选文字颜色适配深色背景（与普通下拉选保持统一风格） */
.ant-select-tree-dropdown {
  color: rgba(255, 255, 255, 0.85) !important;
  background: rgba(20, 30, 40, 0.98) !important;
}

.ant-select-tree-dropdown .ant-select-tree {
  color: rgba(255, 255, 255, 0.85) !important;
}

.ant-select-tree-dropdown .ant-select-tree-node-content-wrapper {
  color: rgba(255, 255, 255, 0.85) !important;
}

.ant-select-tree-dropdown .ant-select-tree-node-content-wrapper:hover {
  background: rgba(108, 221, 255, 0.15) !important;
  color: rgba(255, 255, 255, 0.95) !important;
}

.ant-select-tree-dropdown .ant-select-tree-node-selected .ant-select-tree-node-content-wrapper {
  background: rgba(108, 221, 255, 0.25) !important;
  color: #6cddff !important;
}

.ant-select-tree-dropdown .ant-select-search__field {
  color: rgba(255, 255, 255, 0.85) !important;
  background: rgba(20, 30, 40, 0.5) !important;
  border-color: rgba(108, 221, 255, 0.3) !important;
}

.ant-select-tree-dropdown .ant-select-search__field::placeholder {
  color: rgba(255, 255, 255, 0.45) !important;
}
</style>